import { isObject } from "@/common/transforms";
import { truncateString } from "@/common/utils";
export default {
  quoteId: (state) => state.activeQuote?.selectedQuote?.QuoteId,
  selectedQuote: (state) => state.activeQuote?.selectedQuote,
  allQuestions: (state) => {
    return state.form.sections.reduce((acc, section) => {
      if (!section.SubSections) return acc;

      // if the current section has SubSections
      section.SubSections.forEach((subSection) => {
        if (!subSection.Questions) return;
        // if the current Subsection has Questions
        subSection.Questions.forEach((question) => {
          acc.push(question);
          // if the current Question has Questions
          if (!question.Questions) return;
          question.Questions.forEach((question) => {
            acc.push(question);
          });
        });
      });

      return acc;
    }, []);
  },
  allAnswers: (_, getters) => {
    return (
      getters.allQuestions
        // remove objects that are of DisplayType 'Layout'
        .filter((question) => {
          return question.DisplayType !== "Layout" && question.Value !== null;
        })
        .map((question) => {
          if (isObject(question.Value)) {
            // if question Value Object
            return {
              Value: question.Value.Value.toString(),
              InterfaceKey: question.InterfaceKey,
            };
          } else if (question.Value !== null) {
            // if question Value String
            return {
              Value: question.Value.toString(),
              InterfaceKey: question.InterfaceKey,
            };
          }
        })
    );
  },
  preparedAnswers(_, getters, rootState) {
    // Remove blanks
    let preparedApplyAnswers = getters.allAnswers.filter(
      (ans) => ans && ans.Value !== "" && ans.Value !== null
    );

    const observer = rootState.questions.currentRefObserverForm;

    if (observer && !observer.flags.valid) {
      preparedApplyAnswers = preparedApplyAnswers.filter(
        (a) =>
          !(
            a.InterfaceKey in observer.fields &&
            observer.fields[a.InterfaceKey].invalid
          )
      );
    }

    const paymentMethod = preparedApplyAnswers.find(
      (ans) => ans.InterfaceKey === "PaymentMethod"
    )?.Value;

    const paymentFrequency = preparedApplyAnswers.find(
      (ans) => ans.InterfaceKey === "PaymentFrequency"
    )?.Value;

    const bankSortCode = preparedApplyAnswers.find(
      (answer) => answer.InterfaceKey === "BankSortCode"
    );

    // Limit district value to set number of chars
    preparedApplyAnswers.forEach((question) => {
      if (
        question.InterfaceKey === "CorrespondenceDistrict" ||
        question.InterfaceKey === "SolicitorAddressDistrict"
      ) {
        question.Value = truncateString(question.Value, 0, 30);
      }
    });

    const hasNoEmailAcceptAndNotificationSolicitor = preparedApplyAnswers
      .filter((answer) =>
        ["EmailAcceptToSolicitor", "EmailNotificationToSolicitor"].includes(
          answer.InterfaceKey
        )
      )
      .every((answer) => answer.Value === "false");

    if (paymentMethod && paymentMethod !== "DirectDebit") {
      // For card payment applications remove any DD answers and set auto-renewal to false
      const ddAnswers = [
        "BankAccountName",
        "BankSortCode",
        "BankAccountNo",
        "DirectDebitDate",
        "PaymentFrequency",
        "RepaymentConfirmation",
        "AutoRenewalConsent",
      ];
      preparedApplyAnswers = preparedApplyAnswers.filter(
        (ans) =>
          !ddAnswers.find((ansToRemove) => ans.InterfaceKey === ansToRemove)
      );
      preparedApplyAnswers.push({
        Value: "False",
        InterfaceKey: "AutoRenewalConsent",
      });
    } else if (
      !paymentFrequency ||
      (paymentFrequency && paymentFrequency === "Annual")
    ) {
      // Annual DD - remove RepaymentConfirmation
      const removeAnswers = ["RepaymentConfirmation"];

      preparedApplyAnswers = preparedApplyAnswers.filter(
        (ans) =>
          !removeAnswers.find((ansToRemove) => ans.InterfaceKey === ansToRemove)
      );
    }

    if (bankSortCode && paymentMethod && paymentMethod === "DirectDebit") {
      const bankSortCode = preparedApplyAnswers.find(
        (answer) => answer.InterfaceKey === "BankSortCode"
      );
      bankSortCode.Value = bankSortCode.Value.replaceAll("-", "");
    }

    const solicitorEmailAddressIndex = preparedApplyAnswers.findIndex(
      (answer) => answer.InterfaceKey === "SolicitorEmailAddress"
    );
    if (
      hasNoEmailAcceptAndNotificationSolicitor &&
      solicitorEmailAddressIndex !== -1
    ) {
      preparedApplyAnswers.splice(solicitorEmailAddressIndex, 1);
    }

    return preparedApplyAnswers;
  },
  allSections: (state) => state.form.sections,
  allSubSections: (state) => {
    return state.form.sections.reduce((acc, section) => {
      if (!section.SubSections) return acc;

      // if the current section has SubSections
      section.SubSections.forEach((subSection) => {
        acc.push(subSection);
      });

      return acc;
    }, []);
  },
  getAnswerFromApplyResponse: (state) => (interfaceKey) => {
    const answers = state.applyResponse.Answers;
    const answerObject = answers.find((a) => a.InterfaceKey === interfaceKey);
    if (!answerObject) return;
    return answerObject.Value;
  },
  cardPaymentContinuationDetails: (state) => state.applyResponse.CardPayment,
  secondApplicantSection(_, getters) {
    // returns only "SecondApplicantDetails" Sub Section (object)
    return getters.allSubSections.find((subSection) => {
      return subSection.SectionKey === "SecondApplicantDetails";
    });
  },
  getApplicationReference: (state) => state.applyResponse.ApplicationReference,
  quoteRequestId: (state) => state.applyResponse.QuoteRequestId,
  getRetrievedQuotePaymentFrequency: (_, __, rootState) => {
    return (
      rootState.questions.quoteResponse.Answers.find((answer) => {
        return answer.InterfaceKey === "PaymentFrequency";
      })?.Value ?? null
    );
  },
  getRetrievedQuotePaymentMethod: (_, __, rootState) => {
    return (
      rootState.questions.quoteResponse.Answers.find((answer) => {
        return answer.InterfaceKey === "PaymentMethod";
      })?.Value ?? null
    );
  },
  getTermOfInsurance: (_, __, rootState) => {
    return (
      rootState.questions.quoteResponse.Answers.find((answer) => {
        return answer.InterfaceKey === "TermOfInsurance";
      })?.Value ?? null
    );
  },
  getMonthCoverText: (_, getters) => {
    const term = getters.getTermOfInsurance;
    if (term === "SixMonths") {
      return "6 months cover";
    }
    if (term === "TwelveMonths") {
      return "12 months cover";
    }
    return "";
  },
  getActiveQuoteObjectAsString: (state) => JSON.stringify(state.activeQuote),
  getApplyRequest: (_, getters, rootState) => {
    return {
      CommissionSacrifice: rootState.questions.commissionSacrifice,
      Answers: getters.preparedAnswers,
      CallChannelType: rootState.questions.quoteResponse.CallChannelType,
    };
  },
};
